import { render, staticRenderFns } from "./CailiaotongzhidaneditForm.vue?vue&type=template&id=479a98aa&scoped=true&"
import script from "./CailiaotongzhidaneditForm.vue?vue&type=script&lang=js&"
export * from "./CailiaotongzhidaneditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a98aa",
  null
  
)

export default component.exports